// extracted by mini-css-extract-plugin
export default {"container":"freePlan_container__iMBoU","title":"freePlan_title__Bcm44","record-label":"freePlan_record-label__xYV5V"};